module.exports = {
  ModuleName: 'ชื่อโมดูล',
  OperationChangeTime: 'เวลาการเปลี่ยนแปลงการดำเนินการ',
  Operator: 'ผู้ดำเนินการ',
  To: 'ถึง',
  Close: 'ปิด',
  SerialNumber: 'หมายเลขลำดับ',
  OperationTime: 'เวลาดำเนินการ',
  QueryScheme: 'แผนการสืบค้น',
  QuickSearchBusinessCode: 'การค้นหาด่วน: เลขที่ธุรกิจ',
  YouDidntOpen: 'คุณไม่ได้เปิด',
  FinancialAudit: 'การตรวจสอบทางการเงิน',
  ModulePermissions: 'สิทธิ์ของโมดูล',
  IfTheDataLoadingYears: 'หากช่วงวันที่ที่เลือกมากกว่า 2 ปี อาจส่งผลต่อความเร็วในการโหลดข้อมูล คุณแน่ใจหรือไม่ที่จะค้นหาข้อมูลนอกเหนือจาก 2 ปี?',
  StartDate: 'วันที่เริ่มต้น',
  EndDate: 'วันที่สิ้นสุด',
  ContentDescription: 'คำอธิบายเนื้อหา',
  Name: 'ชื่อ'
}
